<template>
  <v-card>
    <div class="communication-title">
      <span>Comunicação</span>
      <div v-if="hasAnyCommunication" class="communication-title-extra">
        <mf-icon fill icon="paid" color="verde-0" class="icon" :small="isMobile" />
        <span>100% custeada pela indústria</span>
      </div>
    </div>

    <v-divider></v-divider>

    <div class="communication-body">
      <span class="description">
        Cada tipo de campanha, baseada no seu público alvo, tem possibilidades diferentes de comunicação. Abaixo você pode ver quais comunicações serão
        disparadas para a divulgação dessa campanha, totalmente custeadas pela indústria.
      </span>
      <div class="communication-item-container">
        <communication-item :communication="smsCampaign" title="SMS" :segmentationType="getSegmentationType"></communication-item>
        <communication-item :communication="whatsappCampaign" title="Whatsapp" :segmentationType="getSegmentationType"></communication-item>
        <communication-item :communication="pushCampaign" bodyType="push" title="Push Aplicativo" :segmentationType="getSegmentationType"></communication-item>
        <communication-item
          :communication="downloadCampaign"
          title="Enxoval de loja"
          bodyType="download"
          :segmentationType="getSegmentationType"
        ></communication-item>
      </div>
    </div>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'
import CommunicationItem from './CommunicationItem.vue'

export default {
  name: 'CommunicationOfferTrade',
  components: {
    CommunicationItem,
  },
  props: {
    offerSchedule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAnyCommunication() {
      return this.smsCampaign !== null || this.whatsappCampaign !== null || this.pushCampaign !== null || this.downloadCampaign !== null
    },
    getSegmentationType() {
      return this.offerSchedule.industry.is_mercapromo ? 'massive' : this.offerSchedule.segments.length ? 'personalized' : 'club'
    },
    communicationOfferType() {
      if (this.offerSchedule.next_buy_cashback_offer_sales?.length > 0) {
        return 'nextbuycashback'
      } else if (this.offerSchedule.dynamic_rule_offer_sales?.length > 0) {
        return 'digital_voucher'
      } else {
        return 'default'
      }
    },
    smsCampaign() {
      const campaign = this.offerSchedule.campaigns?.find((campaign) => campaign.mode === 'SMS')
      if (campaign) {
        return {
          sendDate: this.formatDate(campaign.message.send_date),
          messageText: campaign.message.text,
        }
      } else {
        let communication
        switch (this.communicationOfferType) {
          case 'digital_voucher':
            communication = this.offerSchedule.communication?.digital_voucher
            break
          case 'nextbuycashback':
            communication = this.offerSchedule.communication?.next_buy_cashback
            break
          default:
            communication = this.offerSchedule.communication?.default
            break
        }
        if (communication?.sms?.active) {
          return {
            sendDate: 'pós compra',
            messageText: communication.sms.message,
          }
        }
      }
      return null
    },
    whatsappCampaign() {
      const campaign = this.offerSchedule.campaigns?.find((campaign) => campaign.mode === 'WHATSAPP')
      if (campaign) {
        return {
          sendDate: this.formatDate(campaign.message.send_date),
          messageText: campaign.message.text,
        }
      } else {
        let communication
        switch (this.communicationOfferType) {
          case 'digital_voucher':
            communication = this.offerSchedule.communication?.digital_voucher
            break
          case 'nextbuycashback':
            communication = this.offerSchedule.communication?.next_buy_cashback
            break
          default:
            communication = this.offerSchedule.communication?.default
            break
        }
        if (communication?.whatsapp?.active) {
          return {
            sendDate: 'pós compra',
            messageText: communication.whatsapp.message,
          }
        }
      }
      return null
    },
    pushCampaign() {
      const campaign = this.offerSchedule.campaigns?.find((campaign) => campaign.mode === 'PUSH')
      if (campaign) {
        return {
          sendDate: this.formatDate(campaign.message.send_date),
          messageTitle: campaign.message.title,
          messageText: campaign.message.text,
        }
      }
      return null
    },
    downloadCampaign() {
      const flyer_url = this.offerSchedule?.industry?.flyer_url
      if (flyer_url) {
        return {
          url: flyer_url,
        }
      }
      return null
    },
  },
  methods: {
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('dd/MM/yyyy')
    },
  },
}
</script>

<style lang="scss" scoped>
.communication-title {
  color: $cinza-d10;
  font-weight: bold;
  display: flex;
  padding: 24px 40px 16px 40px;
  align-items: center;
  font-size: 1.25rem;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 16px;
  }
}

.communication-title-extra {
  color: $verde-0;
  font-size: 1rem;
  margin-left: 8px;

  @media screen and (max-width: $xs-breakpoint) {
    font-size: 12px;
  }

  .icon {
    margin-right: 2px;
  }
}

.communication-body {
  padding: 24px 40px 32px 40px;
  font-size: 14px;
  color: $cinza-d10;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 24px 16px 16px 16px;
  }

  .description {
    display: block;
    margin-bottom: 24px;
  }
}

.communication-item-container {
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 0 8px;
    flex-direction: column;
  }
}
</style>
